export default __webpack_public_path__ + "static/media/maintenance.d7f0963c.png";